import React, { useEffect, useState } from 'react';

import Modal from '../common/Modal';
// Import the CSS file for styling

import { useSmsApi } from '../../auth/helper/api/smsApi';

const SmsSenderModelPage = () => {



  const smsApi = useSmsApi();
  const [senderModels, setSenderModels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false); // State for modal visibility
  const [newSenderModel, setNewSenderModel] = useState({
    senderId: '',
    description: '',
    status: false
  });

const [editDescription, setEditDescription] = useState(''); // Track edited description
const [editingSenderModelId, setEditingSenderModelId] = useState(null); // Track which system variable is being edited
  // State for filters
  const [filters, setFilters] = useState({
    id: null,
    senderId: null,
    description: null,
    status: null
  });

  //for handling pagination
  const [page, setPage] = useState(0); // Starting from the first page
  const [size, setSize] = useState(3); // Number of items per page
  const [totalPages, setTotalPages] = useState(0); // To store total pages

  useEffect(() => {

    const fetchSenderModels = async () => {
      try {
        const response = await smsApi.get(
          process.env
            .REACT_APP_GET_ALL_SMS_SENDERID_BY_PAGE_ENDPOINT,
          {
            params: {
              ...filters,
              page,
              size,
            },
          }
        );
        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) {
          setSenderModels(object.content); // Set the sender-models from the response object
          setTotalPages(object.totalPages);
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching sender-models', err);
        setError(err.message || 'An error occurred.');
        setLoading(false);
      }
    };

    fetchSenderModels();
  }, [smsApi, page, size]);

  const handleInputChange = (e) => {
    const { name, type, checked, value } = e.target;

    setNewSenderModel((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value, // Use checked for checkbox type
    }));
  };

  const handleFilterInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => {
      const newFilters = { ...prev, [name]: value };
      return newFilters;
    });
  };

  // Handle the status change to convert to boolean
  const handleStatusChange = (e) => {
    const value = e.target.value;
    const statusValue = value === 'Active' ? true : value === 'Inactive' ? false : null;

    setFilters((prev) => {
      const newFilters = { ...prev, status: statusValue };
      return newFilters;
    });
  };

  const handleEditClick = (senderModel) => {
    // Set the template being edited
    setEditingSenderModelId(senderModel.id);
    setEditDescription(senderModel.description || "");
  };

  const toggleActivationStatus = async (id, currentStatus) => {

    try {
      const newStatus = !currentStatus; // Toggle the current status
      await smsApi.patch(
        `${process.env.REACT_APP_SET_SMS_SENDERID_STATUS_ENDPOINT}/${id}`,
        { status: newStatus }
      );
      setSenderModels((prev) =>
        prev.map((sender) => sender.id === id ? { ...sender, status: newStatus } : sender)
      );
    } catch (err) {
      setError(err.message || 'An error occurred while updating the status.');
    }
  };

   const handleEditSubmit = async (id) => {

    try {
      // Update sendermodel with PUT request

      await smsApi.put(
        `${process.env.REACT_APP_PUT_SMS_SENDERID_ENDPOINT}/${id}`,
        {
          description: editDescription // value field
        }
      );

      // Refresh the sendermodel list after the update
      const updatedSenderModels = senderModels.map((sender) => {
        if (sender.id === id) {
          return { ...sender, description: editDescription }; // Update the edited system variable
        }
        return sender; // Keep the other records unchanged
      });
      setSenderModels(updatedSenderModels);
      setEditDescription(null); // Reset editing state
      setEditingSenderModelId(null);
    } catch (err) {
      setError(err.message || 'An error occurred while updating the Sender Model.');
    }
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    try {
      const response = await smsApi.post(
        `${process.env.REACT_APP_SET_SMS_SENDERID__ENDPOINT}`,
        newSenderModel
      );
      if (response.status === 200) {
        setSenderModels((prev) => [...prev, response.data.object]); // Update with new category
        setNewSenderModel({ senderId: '', description:'', status: true }); // Reset form
        setError(null);
        setModalOpen(false); // Close modal after submission
      } else {
        setError(`Error: ${response.data.message}`);
      }
    } catch (err) {
      setError(err.message || 'An error occurred while creating the sender model.');
    }
  };

  // New function to apply filters
  const applyFilters = async () => {

    setLoading(true); // Show loading while fetching filtered notifications
    try {
      const response = await smsApi.get(
        process.env
          .REACT_APP_GET_ALL_SMS_SENDERID_BY_PAGE_ENDPOINT,
        {
          params: {
            ...filters,
            page,
            size,
          },
        }
      );
      // Extract data from the response
      const { message, object, httpStatus } = response.data;

      if (httpStatus === 200) {
        setSenderModels(object.content); // Set the sender-models from the response object
        setTotalPages(object.totalPages);
      } else {
        setError(`Error: ${message}`); // Handle non-success status code
      }

      setLoading(false);
    } catch (err) {
      console.error('Error fetching sender-models:', err);
      setError(err.message || 'An error occurred.');
      setLoading(false);
    }
  };

  const handleNextPage = () => {
    if (page + 1 < totalPages) {
      setPage((prevPage) => prevPage + 1); // Increment page number
    }
  };

  const handlePreviousPage = () => {
    if (page > 0) {
      setPage((prevPage) => prevPage - 1); // Decrement page number
    }
  };

  const handleSizeChange = (e) => {
    setSize(e.target.value);
    setPage(0); // Reset to first page on changing size
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading sneder-models: {error}</div>;

  return (
    <div className="category-container">
      <h2>SMS Sender Model</h2>
      <div className="flex-row filter-section">
        <div className='filter-item'>
          <label htmlFor="items-per-page">Items per page: </label>
          <select id="items-per-page" onChange={handleSizeChange} className="w-auto">
            <option value={3}>default</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={5}>5</option>
            <option value={10}>10</option>
          </select>
        </div>
      </div>

      <h3>Filters</h3>
      {/* Filter Form */}
      <div className="flex-row filter-section">
        <div className="filter-item">
          <label>Id:</label>
          <input
            type="text"
            name="id"
            value={filters.id ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>Sender Model Id:</label>
          <input
            type="text"
            name="senderId"
            value={filters.senderId ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>Sender Description:</label>
          <input
            type="text"
            name="description"
            value={filters.description ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>Status:</label>
          <select name="status" onChange={handleStatusChange} value={filters.status === null ? '' : filters.status ? 'Active' : 'Inactive'}>
            <option value="">All</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        <button type="button" onClick={applyFilters}>Apply Filters</button>

      </div>

      {/* Button to open the modal */}
      <button onClick={() => setModalOpen(true)}>+ Create New</button>

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
        <div className="page-container">
          <form onSubmit={handleSubmit} className="standard-form">
            <h3>Create New SMS Sender Model</h3>
            <div className="form-group">
              <label>SMS Sender Id:</label>
              <input
                type="text"
                name="senderId"
                value={newSenderModel.senderId}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>SMS Sender Description:</label>
              <input
                type="text"
                name="description"
                value={newSenderModel.description}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Activation Status:</label>
              <input
                type="checkbox"
                name="status"
                checked={newSenderModel.status}
                onChange={handleInputChange}
              />
            </div>
            <button type="submit">Create Category</button>
          </form>
        </div>
      </Modal>

      <h3>Existing SMS Sender Models</h3>
      {senderModels.length === 0 ? (
        <p>No categories available</p>
      ) : (
        <div className="table-responsive">
          <table className="notifications-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Sender Id</th>
                <th>Description</th>
                <th>Status</th>
                <th>Created At</th>
                <th>Last Updated At</th>
                <th>Last Updated By</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {senderModels.map((sender) => (
                <tr key={sender.id}>
                  <td>{sender.id}</td>
                  <td>{sender.senderId}</td>
                  <td>
                    {editingSenderModelId === sender.id ? (
                      <input
                        type="text"
                        value={editDescription}
                        onChange={(e) => setEditDescription(e.target.value)} // Handle edit description change
                      />
                    ) : (
                      sender.description
                    )}
                  </td>
                   <td>{sender.status ? 'Active' : 'Inactive'}</td>
                  <td>{new Date(sender.createdTimestamp).toLocaleString()}</td>
                  <td>{new Date(sender.updatedTimestamp).toLocaleString()}</td>
                  <td>{sender.lastUpdatedBy}</td>
                  <td>
                    <div className="action-buttons">
                      {editingSenderModelId === sender.id ? (
                        <button onClick={() => handleEditSubmit(sender.id)}>Save</button> // Save edited sms sender model
                      ) : (
                        <button onClick={() => handleEditClick(sender)}>Edit</button> // Set sms sender model to edit
                      )}
                      <button onClick={() => toggleActivationStatus(sender.id, sender.status)}>
                        {sender.status ? 'Disable' : 'Enable'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Pagination Controls */}
      <div className="pagination-container">
        <button onClick={handlePreviousPage} disabled={page === 0}>Previous</button>
        <span>Page {page + 1} of {totalPages}</span>
        <button onClick={handleNextPage} disabled={page + 1 === totalPages}>Next</button>
      </div>
    </div>
  );
};

export default SmsSenderModelPage;